import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import ReactTooltip from 'react-tooltip'
import Loader from 'react-loader'
import config from '../../config'
// import container from '../../helpers/container'
// import format from '../../helpers/format'
// import convert from '../../helpers/convert'
import {
  // YesNo,
  // Grade,
  // GenderEqualityScoreLabel,
  Link,
  LinkIcon
} from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListGetMoreFundsButton extends Component {
  static propTypes = {
    lastResult: PropTypes.array,
    funds: PropTypes.array,
    removeFilters: PropTypes.func,
    loading: PropTypes.bool,
    clickGetMoreFunds: PropTypes.func,
  }

  constructor(props) {
    super(props)
  }

  render() {
    const hasMore = (
      this.props.lastResult &&
      this.props.lastResult.length >= config.queryMaxFunds
    )

    // has results but no funds
    if (this.props.lastResult && this.props.funds.length === 0) {
      return (
        <div styleName='reset-search-wrap'>
          <div styleName='reset-search-info'>
            Sorry, no funds found.
          </div>
          <button
            onClick={this.props.removeFilters}
            styleName='reset-search'
            role='button'
            tabIndex='0'
            title='Reset search filters'
          >
            Reset search filters<LinkIcon faclass='fa-undo' />
          </button>
        </div>
      )
    }

    // has results but there are more funds
    return <div styleName='more-funds-wrapper'>
      <Loader
        options={{scale: 0.70, top:'20%'}}
        loaded={!this.props.loading}
      />
      <div>
        { /* if more funds, show a more funds button, else disable it */
          hasMore ?
            <button
              onClick={this.props.clickGetMoreFunds}
              styleName='more-funds'
              role='button'
              tabIndex='0'
            >
              Get more funds<LinkIcon faclass='fa-plus-circle' />
            </button> :
            <div styleName='no-more-funds'>
              No more funds<LinkIcon faclass='fa-minus-circle' />
            </div>
        }
        { /* if there's no more funds, show a message */
          !hasMore ?
            <div styleName='no-more-funds-info'>
              Looking for your favorite fund and can't find it? <Link
                to={config.links.contact}
                xstrong
              >Let us know</Link> and we'll see if we can add it to our database.
            </div> :
            null
        }
      </div>
    </div>
  }
}